import { toast } from 'react-toastify';
import { createLayer } from './MapUtils';
import { getTranslatedKey } from './TranslateUtils';
import { getAllFeatures, getFeatureByFilter } from '../Llegenda/CapaLlegenda/CapaLlegendaFooter/Components/Taula/TaulaUtils';
import GeoJSON from 'ol/format/GeoJSON';
import { ajaxCall, getPostAddress } from '../Cerca/CercaUtils';
import { fromLonLat, toLonLat, transformExtent } from 'ol/proj';
import Polygon, { circular } from 'ol/geom/Polygon';
import { config } from '../../config/Config';
import WKT from 'ol/format/WKT';
import { Feature } from 'ol';
import { getFeatureFields } from './EdicioCapaUtils';
import { LineString, MultiLineString, MultiPoint, MultiPolygon, Point } from 'ol/geom';

export const getParentURL = () => {
  let parentURL;
  try {
    parentURL = window.parent.location.origin;
  } catch (error) {
    parentURL = document.referrer;
  }
  if (parentURL && parentURL.endsWith('/')) parentURL = parentURL.slice(0, -1);
  return parentURL;
};

export const apiPermissions = async (token, id) => {
  let parentURL = getParentURL();

  if (!parentURL) {
    toast.error('Error en obtenir la URL pare');
    console.error("Validació de permisos: No s'ha pogut obtenir la URL del client");
    return false;
  }
  if (parentURL && token) {
    const url = '/admin/server/mapa/validarToken';

    const body = {
      urlClient: parentURL,
      token: token,
      idVisor: id
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      toast.error('Error al validar el token');
      return false;
    }
    return await response.json();
  }
};

export const getFeatureById = async (layer, featureID) => {
  if (layer) {
    const id = layer.getExtension().Id;
    const filter = `${id} = ${featureID}`;
    const resp = await getFeatureByFilter(layer, filter);
    let fc = new GeoJSON().readFeatures(resp);
    let feature = fc[0];
    return feature;
  } else {
    toast.error('Error');
    return;
  }
};

export const getFeaturesWithFilter = async (layerName, field, value, sitepLayers, arrayLayers, map, externalLayers) => {
  const layer = arrayLayers.find((loadedLayer) => loadedLayer.getName() === layerName);
  if (layer) {
    const fields = await getFeatureFields(layer, true);
    const fieldType = fields.find((prop) => prop.field === field.trim()).type;
    const operator = fieldType !== 'text' ? `=${value}` : ` ILIKE '${value}'`;

    const filter = `${field}${operator}`;

    const resp = await getAllFeatures(layer, filter);
    let fc = new GeoJSON().readFeatures(resp);
    if (fc.length === 0) {
      toast.error(getTranslatedKey('error_noFeatures'));
      return [];
    }
    return fc;
  }
};

const loadLayer = async (layerName, sitepLayers, arrayLayers, map, externalLayers) => {
  let isLoaded = arrayLayers.find((layer) => layer.getName() === layerName);
  if (isLoaded) {
    return;
  }
  let sitepLayer = sitepLayers.find((layer) => layer.name === layerName);

  if (!sitepLayer) {
    for (let lay of externalLayers) {
      if (lay.getNumChilds() > 0) {
        let foundSubLayer = lay.getChildLayers().find((subLay) => subLay.name === layerName);
        if (foundSubLayer) {
          sitepLayer = foundSubLayer;
          break;
        }
      }
      if (lay.name === layerName) {
        sitepLayer = lay;
        break;
      }
    }
  }
  if (sitepLayer) {
    await createLayer(sitepLayer, map, arrayLayers);
  } else {
    toast.error(getTranslatedKey('layerNotLoaded1') + ` ${layerName} ` + getTranslatedKey('layerNotLoaded2'));
  }
};

export const loadLayers = async (layers, map, sitepLayers, arrayLayers, externalLayers, context) => {
  let splittedLayers = layers.split(',').map((layer) => layer.trim());
  splittedLayers.reverse().forEach(async (layerName) => {
    await loadLayer(layerName, sitepLayers, arrayLayers, map, externalLayers);
  });
  context.setState({ loading: false });
};

export const zoomToBboxApi = (bbox, map) => {
  map.getView().fit(bbox, { minResolution: 1, padding: [60, 60, 60, 60] });
};

export const goToLocation = (addCercaToponim, clearArElements, zoomCoord, search, handleLoadingLoc, infoPunt) => {
  const searchTerm = search.replace(/:/g, '\\:');
  const post = getPostAddress(searchTerm);
  let action = 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaAdreca';
  ajaxCall('Address', post, action, addCercaToponim, zoomCoord, handleLoadingLoc, clearArElements, false, false, infoPunt);
};

export const getBboxFilter = (layer, type, geom, epsg) => {
  const format = new WKT();
  const geometryName = layer.getExtension().Geometry;
  if (type === 'bbox') {
    let bbox = geom;
    bbox = transformExtent(bbox, epsg, config.EPSG);
    bbox = `BBOX(${geometryName}, ${bbox})`;
    return bbox;
  } else if (type === 'cercle') {
    let center = geom[0];
    let radius = geom[1];
    center = toLonLat(center, epsg);
    let circlePol = circular(center, radius);
    let circlePolConverted = circlePol.getCoordinates()[0].map((coord) => {
      return fromLonLat(coord, config.EPSG);
    });
    let wkt = format.writeGeometry(new Polygon([circlePolConverted]));
    wkt = `INTERSECTS(${geometryName}, ${wkt})`;
    return wkt;
  } else if (type === 'poligon') {
    const polygonFeature = new Feature({
      geometry: new Polygon([geom])
    });
    let pol = polygonFeature.getGeometry();
    pol = pol.transform(epsg, config.EPSG);
    let wkt = format.writeGeometry(pol);
    wkt = `INTERSECTS(${geometryName}, ${wkt})`;
    return wkt;
  }
};

export const makeGeomMulti = (features) => {
  features.forEach((feature) => {
    const geometry = feature.getGeometry();
    if (geometry instanceof Polygon) {
      feature.setGeometry(new MultiPolygon([geometry.getCoordinates()]));
    } else if (geometry instanceof LineString) {
      feature.setGeometry(new MultiLineString([geometry.getCoordinates()]));
    } else if (geometry instanceof Point) {
      feature.setGeometry(new MultiPoint([geometry.getCoordinates()]));
    }
  });
  return features;
};
